/**
 * Pure screen-space geometry for the drawing engine — Phase 6a-1 commit 2 of
 * the decomposition (briefs/ARCHITECTURE_DECOMPOSITION_BLUEPRINT.md §6, A16j
 * pure subset, v2.2/R18 rescope). Body moved VERBATIM from static/index.html.
 *
 * Deliberately NOT here (blueprint R3): findDrawingNear — it iterates the
 * page's state.drawings, filters on the bridged state.symbol, and resolves
 * pixels through the bridge-reading coordinate resolvers (H24). It stays in
 * static/index.html.
 */

/** Distance from point (px,py) to the SEGMENT (x1,y1)-(x2,y2), in pixels. */
export function pointToSegmentDistance(
  px: number, py: number,
  x1: number, y1: number,
  x2: number, y2: number,
): number {
  const dx = x2 - x1, dy = y2 - y1;
  if (dx === 0 && dy === 0) return Math.hypot(px - x1, py - y1);
  let t = ((px - x1) * dx + (py - y1) * dy) / (dx * dx + dy * dy);
  t = Math.max(0, Math.min(1, t));
  return Math.hypot(px - (x1 + t * dx), py - (y1 + t * dy));
}
